namespace RedBullMOBILE360.Sms {
    export class CampaignEligibilityColumns {
        static columnsKey = 'Sms.CampaignEligibility';
    }
}